import React, { useState } from 'react';

// ui
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

// components
import StormHistoryCriteriaJtwc from './StormHistoryCriteriaJtwc';
import StormHistoryMapJtwc from './StormHistoryMapJtwc';
import StormHistoryLegendTable from './StormHistoryLegendTable';
import { StormListJtwcMemo } from './StormListJtwc';

// main  style
import {
  styles,
} from '../style';

// context
import StormContext from '../../../../context/stormContext';

const useStyles = makeStyles(styles);

// constant
// const initPath = process.env.REACT_APP_PATH;

function getModalStyle() {
  const top = 0;
  const left = 0;
  const right = 0;
  const bottom = 0;

  return {
    top: `${top}%`,
    left: `${left}%`,
    right: `${right}%`,
    bottom: `${bottom}%`,
    margin: 'auto',
    width: '90%',
    height: '90%',
    overflowY: 'auto',
    backgroundColor: '#FFF',
    padding: '20px',
    position: 'absolute',
  };
}

export default function StormHistoryJtwc() {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [activeLayer, setLayer] = useState({});
  const [modalStyle] = useState(getModalStyle);
  const [modal, setModal] = useState({
    open: false,
    modalHeader: null,
    modalSubHeader: null,
    modalContent: null,
  });

  const handleToggleLayer = (id, value) => {
    // console.log(`handleToggleLayer: ${id}, status: ${value}`);

    // set map hidden state
    setLayer({
      ...activeLayer,
      [id]: value,
    });
  };

  const handleData = (datas) => {
    setData(datas);
  };

  const handleActiveLayer = (layers) => {
    setLayer(layers);
  };

  const handleModalOpen = (params) => {
    setModal({
      open: true,
      modalHeader: params.header,
      modalSubHeader: params.subheader,
      modalContent: params.content,
    });
  };

  const handleModalClose = () => {
    setModal({ ...modal, open: false });
  };

  return (
    <div className={classes.layout}>
      <StormHistoryCriteriaJtwc
        handleActiveLayer={handleActiveLayer}
        handleData={handleData}
      />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={9} md={10} lg={10}>
          <StormContext.Provider
            value={{
              handleModalOpen,
            }}
          >
            <StormHistoryMapJtwc data={data} activeLayer={activeLayer} />
          </StormContext.Provider>
          <StormHistoryLegendTable />
        </Grid>
        <Grid item xs={12} sm={3} md={2} lg={2}>
          <Box style={{ borderRadius: 6, border: '1px solid #ccc' }}>
            <StormListJtwcMemo data={data} handleToggleLayer={handleToggleLayer} />
          </Box>
        </Grid>
      </Grid>

      <Modal
        id="modal-chart"
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={modal.open}
        onClose={handleModalClose}
        style={{ align: 'center', justifyContent: 'center' }}
      >
        <div style={modalStyle} className={classes.paper}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={0}
          >
            <Grid item>
              <IconButton onClick={handleModalClose} style={{ padding: 0 }}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Grid>
          </Grid>
          <Typography variant="h5" id="modal-title">
            {modal.modalHeader}
          </Typography>
          <Typography variant="subtitle1" id="simple-modal-description">
            {modal.modalSubHeader}
          </Typography>
          <Box mt={3}>
            {modal.modalContent}
          </Box>
        </div>
      </Modal>
    </div>
  );
}

// For reference : https://www.thaiwater.net/TyphoonTracking/storm/storm.html
